import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { Box, useTheme } from '@mui/material'

import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'
import api from '../../service/api'

const AuditStudyMaterials = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.fetchStudyMaterialCounts( { last30dayscount: true, institute, department } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the assignment audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )


    useEffect( () => {
        getData()
    }, [getData] )


    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Study materials audit"
                subtitle="View all study materials activities here."
                countCards={[
                    {
                        icon: Icons.default.QuizIcon,
                        label: "Study Materials",
                        value: getCountString( counts.totalStudyMaterialCount ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Group,
                        label: "Attchments",
                        value: getCountString( counts.totalStudyMaterialAttachmentsCount ),
                        secondary: getCountString( counts.last30daysAttachmentsCount ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />

            {/* <Box sx={{ flexShrink: 0 }}>
                <Box display="flex" flexWrap="wrap" gap="20px" justifyContent="space-between" >
                    <Box display="flex" flexGrow={1} gap="20px" flexDirection="column" justifyContent="space-between">
                        <Box>
                            <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px" >Study materials audit</Typography>
                            <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>View all study materials activities here.</Typography>
                        </Box>
                        {!error && <Box display="grid" gap="20px" width="100%" gridTemplateColumns={{ md: "repeat(6,1fr)", xs: "repeat(2,1fr)" }}>
                            <CountCard loading={loading} variant="stacked" label='Study Materials' icon={Icons.default.Subjects} value={getCountString( counts.totalStudyMaterialCount )} secondary={getCountString( counts.last30daysCount )} secondaryLabel="In last 30 days" />
                            <CountCard loading={loading} variant="stacked" label='Attchments' icon={Icons.default.DescriptionIcon} value={getCountString( counts.totalStudyMaterialAttachmentsCount )} secondary={getCountString( counts.last30daysAttachmentsCount )} secondaryLabel="In last 30 days" />
                        </Box>}
                        <Box>
                            <Box display="flex" gap="20px" flexWrap="wrap">

                                {( UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) && <InstituteSelect disabled={loading} selectedInstitute={selectedInstitute} handleInstituteChange={handleInstituteChange} />}

                                {( UserStore.getUser.user_role === 'PRINCIPAL' || UserStore.getUser.user_auditor || ["ADMIN", "SUBADMIN"].includes( UserStore.getUser?.user_role?.toUpperCase() ) ) && <DepartmentSelect disabled={loading || loadingDepartments || ( selectedInstitute === "all" && UserStore.getUser.user_role !== 'PRINCIPAL' )} departments={departments} handleDepartmentChange={val => setSearchParamValue( 'selectedDepartment', val )} selectedDepartment={selectedDepartment} />}

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box> */}
            {error && <Box sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditStudyMaterials
